import { Alert } from '@mui/material';

export const AlertStyled = ({text, severity, ...props}) => {
  return (
    <>
      <Alert severity={severity}>{text}</Alert>
    </>
  );
};
